import { IThread } from '~/client/graph'
import Delivery from '~/client/src/shared/models/Delivery'
import Thread from '~/client/src/shared/models/Thread'
import BaseActionBarStore from '~/client/src/shared/stores/ui/BaseActionBar.store'
import MessageDto from '~/client/src/shared/types/MessageDto'

import IAttachmentAdditionalInfo from '../../types/IAttachmentAdditionalInfo'
import BaseFollowingsStore from '../BaseFollowings.store'
import DeliveriesStore from '../domain/Deliveries.store'
import { FileUploadingStore } from '../domain/FileUploading.store'
import MessagesStore from '../domain/MessagesStore/Messages.store'
import PhotosStore from '../domain/Photos.store'
import TagsStore from '../domain/Tags.store'
import ThreadsStore from '../domain/ThreadsStore/Threads.store'
import UserProjectsStore from '../domain/UserProjects.store'
import EventsStore from '../EventStore/Events.store'

export default class DeliveryActionBarStore extends BaseActionBarStore {
  public constructor(
    private readonly deliveriesStore: DeliveriesStore,
    eventsStore: EventsStore,
    threadsStore: ThreadsStore,
    messagesStore: MessagesStore,
    photosStore: PhotosStore,
    fileUploadingStore: FileUploadingStore,
    userProjectsStore: UserProjectsStore,
    tagsStore: TagsStore,
    private readonly getAttachmentAdditionalInfo: () => IAttachmentAdditionalInfo,
    baseFollowingStore?: BaseFollowingsStore,
  ) {
    super(
      eventsStore,
      threadsStore,
      messagesStore,
      photosStore,
      fileUploadingStore,
      userProjectsStore,
      tagsStore,
      baseFollowingStore,
    )
  }

  protected updateThreadEntity(threadEntity: Delivery) {
    this.deliveriesStore.updateDelivery(threadEntity, null, false)
  }

  protected async postMessageWithAttachments(
    text: string,
    thread: Thread | IThread | string,
    fileImage: File,
    file: File = null,
    threadEntityId?: string,
  ): Promise<MessageDto> {
    const attachmentAdditionalInfo = this.getAttachmentAdditionalInfo()
    return super.postMessageWithAttachments(
      text,
      thread,
      fileImage,
      file,
      threadEntityId,
      attachmentAdditionalInfo,
    )
  }
}
